import _ from 'lodash';
import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { getIconByLabel } from './EnumMapping';

export const dateTimeOptions = {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', second: 'numeric'
}

export const dateOptions = {
    year: 'numeric', month: '2-digit', day: '2-digit'
}

export const yearMonthOptions = {
    year: 'numeric', month: '2-digit'
}

export const yearOptions = {
    year: 'numeric'
}

export function DateTimeCell(props) {
    if (props.value && !_.isEmpty(props.value)) {
        return <>{new Intl.DateTimeFormat("hu-HU", dateTimeOptions).format(new Date(props.value))}</>

    } else {
        return '';
    }
}

export function DateCell({ value, options }) {
    if (value && !_.isEmpty(value)) {
        const date = new Date(value);
        const result = options?.predicate?.(date) || false;
        return <span className={`${result ? options.additionalClassName : ''}`}>{new Intl.DateTimeFormat("hu-HU", dateOptions).format(date)}</span>
    } else {
        return '';
    }
}

export function DateCellPastInRed(props) {
    if (props.value && !_.isEmpty(props.value)) {
        return <>{new Intl.DateTimeFormat("hu-HU", dateOptions).format(new Date(props.value))}</>
    } else {
        return '';
    }
}

export function YearMonthCell(props) {
    if (props.value) {
        return <>{new Intl.DateTimeFormat("hu-HU", yearMonthOptions).format(props.value)}</>
    } else {
        return '';
    }
}

export function YearCell(props) {
    if (props.value) {
        return <>{new Intl.DateTimeFormat("hu-HU", yearOptions).format(props.value)}</>
    } else {
        return '';
    }
}

export function IconCell(props) {
    return getIconByLabel(props.list, props.label)
}

export function CharCell(props) {
    return getIconByLabel(props.list, props.label)

}

export function NumberCell(props) {
    // console.log(props);
    if (props.value !== undefined && props.value !== null && !isNaN(props.value) && props.value !== '') {
        return <>{new Intl.NumberFormat("hu-HU").format(props.value)}</>
    } else {
        return '';
    }
}

const defaultMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ' ',
    allowDecimal: true,
    //decimalSymbol: '.',
    //decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 15, // limit length of integer numbers
    allowNegative: true,
    allowLeadingZeroes: false,
}

const positiveMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ' ',
    allowDecimal: true,
    //decimalSymbol: '.',
    //decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 15, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
}

export const NumberInput = ({ maskOptions, ...inputProps }) => {
    const numberMask = createNumberMask({
        ...defaultMaskOptions,
        ...maskOptions,
    })
    let { inputRef, ...others } = inputProps;
    return <MaskedInput mask={numberMask} {...others} placeholder={inputProps.placeholder || ''} />
}

export const PositiveNumberInput = ({ maskOptions, ...inputProps }) => {
    const numberMask = createNumberMask({
        ...positiveMaskOptions,
        ...maskOptions,
    })
    let { inputRef, ...others } = inputProps;
    return <MaskedInput mask={numberMask} {...others} placeholder={inputProps.placeholder || ''} />
}

export const BankInput = ({ maskOptions, ...inputProps }) => {

    const { inputRef, ...other } = inputProps;
    return <MaskedInput mask={bankMask} guide={true} {...other} />//placeholderChar={'\u2000'} />
}

const bankMask = (rawValue) => {
    let raw = rawValue.replaceAll(' ', '');
    let r = raw.replaceAll('-', '');
    if (isNaN(r)) {
        let rr = r.slice(0, -1);
        r = rr;
    }
    let result = [];
    /* eslint-disable no-fallthrough */
    /* eslint-disable default-case */
    switch (r.length) {
        case 25:
        case 24:
            result.push(/\d/);
        case 23:
            result.push(/\d/);
        case 22:
            result.push(/\d/);
        case 21:
            result.push(/\d/);
            result.push(' ');
        case 20:
            result.push(/\d/);
        case 19:
            result.push(/\d/);
        case 18:
            result.push(/\d/);
        case 17:
            result.push(/\d/);
            result.push(' ');
            result.push('-');
            result.push(' ');
        case 16:
            result.push(/\d/);
        case 15:
            result.push(/\d/);
        case 14:
            result.push(/\d/);
        case 13:
            result.push(/\d/);
            result.push(' ');
        case 12:
            result.push(/\d/);
        case 11:
            result.push(/\d/);
        case 10:
            result.push(/\d/);
        case 9:
            result.push(/\d/);
            result.push(' ');
            result.push('-');
            result.push(' ');
        case 8:
            result.push(/\d/);
        case 7:
            result.push(/\d/);
        case 6:
            result.push(/\d/);
        case 5:
            result.push(/\d/);
            result.push(' ');
        case 4:
            result.push(/\d/);
        case 3:
            result.push(/\d/);
        case 2:
            result.push(/\d/);
        case 1:
            result.push(/\d/);
    }
    return result.reverse();
}

export const TaxInput = ({ maskOptions, ...inputProps }) => {

    const { inputRef, ...other } = inputProps;
    return <MaskedInput mask={taxMask} guide={true} {...other} />//placeholderChar={'\u2000'} />
}

const taxMask = (rawValue) => {
    let raw = rawValue.replaceAll(' ', '');
    let r = raw.replaceAll('-', '');
    if (isNaN(r)) {
        let rr = r.slice(0, -1);
        r = rr;
    }
    let result = [];

    /* eslint-disable no-fallthrough */
    /* eslint-disable default-case */
    switch (r.length) {
        case 12:
        case 11:
            result.push(/\d/);
        case 10:
            result.push(/\d/);
            result.push('-');
        case 9:
            result.push(/\d/);
            result.push('-');
        case 8:
            result.push(/\d/);
        case 7:
            result.push(/\d/);
        case 6:
            result.push(/\d/);
        case 5:
            result.push(/\d/);
        case 4:
            result.push(/\d/);
        case 3:
            result.push(/\d/);
        case 2:
            result.push(/\d/);
        case 1:
            result.push(/\d/);
    }
    return result.reverse();
}
